import { render, staticRenderFns } from "./login1.vue?vue&type=template&id=bf10da6e&scoped=true&"
import script from "./login1.vue?vue&type=script&lang=js&"
export * from "./login1.vue?vue&type=script&lang=js&"
import style0 from "./login1.vue?vue&type=style&index=0&id=bf10da6e&prod&lang=scss&"
import style1 from "./login1.vue?vue&type=style&index=1&id=bf10da6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf10da6e",
  null
  
)

export default component.exports